import { useLocation, useNavigate } from 'react-router';
import Icon, { Icons } from '../../components/Icon/Icon';
import PageHeader from '../../components/PageHeader';
import './PersonaInfo.scss';
import AppConfig from '../../config';

const { routes } = AppConfig;

const PersonalInfo = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const data = location.state;

	const openEditInfo = () => {
		navigate({ pathname: routes.editPersonalInfo }, { state: data });
	};

	return (
		<div>
			<PageHeader header='Personal info' collapsed={true} />

			<div class='personal-info'>
				<div class='info-row'>
					<span class='label'>Full name</span>
					<span class='value'>
						{/* {data.fullName} */}
						Alexandr Wike
					</span>
				</div>

				<div class='info-row'>
					<span class='label'>Phone</span>
					<span class='value'>
						{/* {data.phone} */}
						+380 50 392 39 47
					</span>
				</div>

				<div class='info-row'>
					<span class='label'>Email</span>
					<span class='value'>
						{/* {data.email} */}
						wilialexa@gmail.com
					</span>
				</div>

				<button class='edit-btn' onClick={openEditInfo}>
					<Icon type={Icons.PENCIL_LINE} width={24} height={24} />
					Edit info
				</button>
			</div>
		</div>
	);
};

export default PersonalInfo;
